module.exports = __webpack_public_path__ + "static/media/PATS_7-768w.ada8407e.png";